import { render } from "./App.vue?vue&type=template&id=3d6b2a5d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3d6b2a5d&lang=scss"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__